import { render, staticRenderFns } from "./legr_detail.vue?vue&type=template&id=172c35ff&scoped=true"
import script from "./legr_detail.vue?vue&type=script&lang=js"
export * from "./legr_detail.vue?vue&type=script&lang=js"
import style0 from "./legr_detail.vue?vue&type=style&index=0&id=172c35ff&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172c35ff",
  null
  
)

export default component.exports